//Base Libraries
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "REDUX/store";

// import registerServiceWorker from "./registerServiceWorker";
import { unregister } from './registerServiceWorker';

//Components
import App from "MODULES/App/App";

//Configurations
import config from "CONFIG/environment";
import configureAxios from "CONFIG/axios.init";

//Localisation Libraries
import { I18nextProvider } from "react-i18next";
import i18n from "INTL/i18n";

//Styles
import "bootstrap/dist/css/bootstrap.css";
// import "tabler-react/dist/Tabler.css"
import "font-awesome/css/font-awesome.min.css";
import "react-toastify/dist/ReactToastify.css";
import "STYLES/fonts.less";
import "STYLES/index.less";

// ========================================================
// Axios Setup
// ========================================================
configureAxios(config.serverURL);

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>,
  MOUNT_NODE
);

// Added to fix Redmine Ticket #6410 - Webapp: ServiceWorker preventing MiGS callback from reaching the server
unregister();
// registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js